module.exports = __webpack_public_path__ + "img/green-carpet-grass-01.53c7d2f8.png";